export const userTypes = {
  getters: {
    getUserList: "getUserList",
    getUserIndex: "getUserIndex",
    getWeekList: "getWeekList",
    getUser: "getUser",
    getKeyword: "getKeyword"
  },
  actions: {
    QUERY_USER_LIST: "QUERY_USER_LIST",
    QUERY_SINGLE_USER: "QUERY_SINGLE_USER",
    ADD_USER: "ADD_USER",
    EDIT_USER: "EDIT_USER",
    DELETE_USER: "DELETE_USER",
    EDIT_USER_CASH_BAG: "EDIT_USER_CASH_BAG",
    GET_USER_LIST_LENGTH: "GET_USER_LIST_LENGTH",
    GET_SEARCH_KEYWORD: "GET_SEARCH_KEYWORD",
    QUERY_USER_PHONE: "QUERY_USER_PHONE"
  },
  mutations: {
    GET_USER_LIST: "GET_USER_LIST",
    GET_SINGLE_USER: "GET_SINGLE_USER",
    SET_USER_INDEX: "SET_USER_INDEX",
    SET_SEARCH_KEYWORD: "SET_SEARCH_KEYWORD",
    SET_SEARCH_PAGE: "SET_SEARCH_PAGE"
  }
};
export const orderTypes = {
  getters: {
    getOrderList: "getOrderList",
    getTodayOrderList: "getTodayOrderList",
    getUser: "getUser",
    getTotalOrderList: "getTotalOrderList"
  },
  mutations: {
    SET_ORDER_LIST: "SET_ORDER_LIST",
    SET_TODAY_ORDER_LIST: "SET_TODAY_ORDER_LIST",
    SET_TOTAL_ORDER_LIST: "SET_TOTAL_ORDER_LIST",
    SET_SINGLE_USER_ORDER_LIST: "SET_SINGLE_USER_ORDER_LIST",
    SCAN_ORDER_LIST: "SCAN_ORDER_LIST"
  },
  actions: {
    QUERY_TODAY_ORDER_LIST: "QUERY_TODAY_ORDER_LIST",
    QUERY_ORDER_TOTAL: "QUERY_ORDER_TOTAL",
    ADD_ORDER: "ADD_ORDER",
    EDIT_ORDER: "EDIT_ORDER",
    DELETE_ORDER: "DELETE_ORDER",
    QUERY_USER_ORDER_IN_MONTH: "QUERY_USER_ORDER_IN_MONTH",
    GET_TODAY_ORDER_LIST: "GET_TODAY_ORDER_LIST",
    GET_SINGLE_USER_ORDER_LIST: "GET_SINGLE_USER_ORDER_LIST",
    GET_ORDER_SETTLED_LIST: "GET_ORDER_SETTLED_LIST",
    EDIT_BAG: "EDIT_BAG"
  }
};
export const revenueTypes = {
  getters: {
    getPaymentRevenueList: "getPaymentRevenueList",
    getReceiveRevenueList: "getReceiveRevenueList"
  },
  mutations: {
    SET_PAYMENT_REVENUE: "SET_PAYMENT_REVENUE",
    SET_RECEIVE_REVENUE: "SET_RECEIVE_REVENUE"
  },
  actions: {
    QUERY_PAYMENT_REVENUE: "QUERY_PAYMENT_REVENUE",
    QUERY_RECEIVE_REVENUE: "QUERY_RECEIVE_REVENUE",
    ADD_PAYMENT_REVENUE: "ADD_PAYMENT_REVENUE",
    EDIT_PAYMENT_REVENUE: "EDIT_PAYMENT_REVENUE",
    DELETE_PAYMENT_REVENUE: "DELETE_PAYMENT_REVENUE"
  }
};
